import type { RouteRecordRaw } from 'vue-router'
import { readListScope } from '@/shared/scope/listScope'
import { buildUcUserCallFlowSettingsAccountRoute } from './call-flow-settings/constants'

export const ucUserRoutes: RouteRecordRaw[] = [
  {
    path: '/uc-user/automations',
    name: 'uc-user-automations',
    component: () => import('./automations/pages/AutomationsPage.vue')
  },
  {
    path: '/uc-user/automations/:id/edit',
    name: 'uc-user-automation-edit',
    component: () => import('./automations/pages/AutomationEditPage.vue'),
    props: true
  },
  {
    path: '/uc-user/blocked-numbers',
    name: 'uc-user-blocked-numbers',
    component: () => import('./blocked-numbers/pages/UcUserBlockedNumbersPage.vue')
  },
  {
    path: '/uc-user/phonebooks',
    name: 'uc-user-phonebooks',
    component: () => import('./phonebooks/pages/UcUserPhonebooksPage.vue')
  },
  {
    path: '/uc-user/phonebooks/:id',
    name: 'uc-user-phonebooks-show',
    component: () => import('./phonebooks/pages/UcUserPhonebookShowPage.vue'),
    props: true
  },
  {
    path: '/uc-user/call-flow-settings',
    name: 'uc-user-call-flow-settings',
    component: () => import('./call-flow-settings/pages/CallFlowSettingsPage.vue'),
    beforeEnter: (to) => {
      const accountId = readListScope(to.query).accountId
      if (accountId) {
        return buildUcUserCallFlowSettingsAccountRoute(accountId, to.query)
      }
    }
  },
  {
    path: '/uc-user/call-flow-settings/account',
    name: 'uc-user-call-flow-settings-account',
    component: () => import('./call-flow-settings/pages/CallFlowSettingsAccountPage.vue')
  },
  {
    path: '/uc-user/call-flow-settings/multiway-toggles/:id',
    name: 'uc-user-multiway-toggle-show',
    component: () => import('./call-flow-settings/pages/UcUserMultiwayToggleShowPage.vue'),
    props: true
  },
  {
    path: '/uc-user/extension-settings',
    name: 'uc-user-extension-settings',
    component: () => import('./extension-settings/pages/UcUserExtensionSettingsPage.vue')
  },
  {
    path: '/uc-user/extension-settings/:id',
    name: 'uc-user-extension-settings-show',
    component: () => import('./extension-settings/pages/UcUserExtensionSettingsShowPage.vue'),
    props: true
  },
  {
    path: '/uc-user/schedules/:id',
    name: 'uc-user-schedule-edit',
    component: () => import('./call-flow-settings/pages/UcUserScheduleEditPage.vue'),
    props: true
  },
  {
    path: '/uc-user/voicemails',
    name: 'uc-user-voicemails',
    component: () => import('./voicemails/pages/UcUserVoicemailsPage.vue')
  },
  {
    path: '/uc-user/voicemails/:id',
    name: 'uc-user-voicemails-show',
    component: () => import('./voicemails/pages/UcUserVoicemailsShowPage.vue'),
    props: true
  },
  {
    path: '/uc-user/faxing',
    name: 'uc-user-faxing',
    component: () => import('./faxing/pages/UcUserFaxingPage.vue')
  },
  {
    path: '/uc-user/faxing/:phoneNumberId',
    name: 'uc-user-faxing-show',
    component: () => import('./faxing/pages/UcUserFaxingShowPage.vue'),
    props: true
  },
  {
    path: '/uc-user/messaging',
    name: 'uc-user-messaging',
    component: () => import('./messaging/pages/UcUserMessagingPage.vue')
  },
  {
    path: '/uc-user/messaging/:phoneNumberId',
    name: 'uc-user-messaging-show',
    component: () => import('./messaging/pages/UcUserMessagingShowPage.vue'),
    props: true
  }
]
